// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ChevronLeft(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChevronLeft" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M7.25 12L13.6036 5.64641L15.3669 7.40977L10.7867 12L15.3669 16.5902L13.6036 18.3535L7.25 12Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ChevronLeft.js.map